module.exports = __webpack_public_path__ + "img/payment_paypal.703b97a2.svg";